/**
 * Contact Form - Submit Handler
 *
 * Simple, event-driven form submission
 * No workarounds, no defensive programming
 * Trust the framework - form submission works or fails naturally
 */

document.addEventListener('DOMContentLoaded', function() {
    const contactForm = document.querySelector('#contact-form');
    const submitBtn = document.querySelector('.btn-submit');

    if (!contactForm || !submitBtn) {
        return;
    }

    const originalBtnText = submitBtn.innerHTML;

    contactForm.addEventListener('submit', function() {
        // Disable button and show loading state
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<span class="spinner">⏳</span> Enviando...';
    });
});
